<template>
    <Card>
      <LocalDataTable :init-document="is_mounted" :functions="functions" ajax-link="admin/Guild/List" :columns="columns"></LocalDataTable>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import Swal from "sweetalert2";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
name: "GuildList",
  components: {LocalDataTable, Card, MasterLayout},
  data()
  {
    return{
      is_mounted : mounted,
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      columns : [{title : 'عنوان'},{title : 'وضعیت بازار'},{title : '<i class="far fa-cogs"></i>'}]
    }
  },
  async mounted()
  {
    this.setPageTitle('لیست اصناف');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  },methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
    async delFunc(id,title,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به صنف کاری "+title+" حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deleteGuild(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>